import {_t} from '../utils/translations'
import marketTypes from './market-types';

export const getOutcomeFullName = (outcomeName: string): string => {
  let newOutcomeName: string = ''

  switch (outcomeName) {
    case '1':
      newOutcomeName = _t('Win');
      break;
    case '2':
      newOutcomeName = _t('Loss');
      break;
    case 'X':
      newOutcomeName = _t('Draw');
      break;
    default:
      newOutcomeName = outcomeName;
  }

  return newOutcomeName
}

export enum Outcomes {
  // Outcomes.
  OUTCOME_1 = '1',
  OUTCOME_X = 'X',
  OUTCOME_2 = '2',
  OUTCOME_OVER = 'Over',
  OUTCOME_UNDER = 'Under',
  OUTCOME_EXACT = 'Exact',
  OUTCOME_ODD = 'Odd',
  OUTCOME_EVEN = 'Even',
  OUTCOME_1X = '1X',
  OUTCOME_X2 = 'X2',
  OUTCOME_12 = '12',
  OUTCOME_YES = 'Yes',
  OUTCOME_NO = 'No',
  OUTCOME_1_X = '1/X',
  OUTCOME_2_X = '2/X',
  OUTCOME_X_1 = 'X/1',
  OUTCOME_X_2 = 'X/2',
  OUTCOME_X_X = 'X/X',
  OUTCOME_1_1 = '1/1',
  OUTCOME_1_2 = '1/2',
  OUTCOME_2_1 = '2/1',
  OUTCOME_2_2 = '2/2',
}

export enum OutcomeIds {
  OUTCOME_1 = 1,
  OUTCOME_2 = 3,
  OUTCOME_X = 2,
  OUTCOME_OVER = 4,
  OUTCOME_UNDER = 5,
}

export function getOutcomeNamesByMarketTypeId(marketTypeId: number): string[] {
  switch (marketTypeId) {
    case marketTypes.MT_1X2_ID:
    case marketTypes.MT_EH_ID:
      return [Outcomes.OUTCOME_1, Outcomes.OUTCOME_X, Outcomes.OUTCOME_2];

    case marketTypes.MT_AH_ID:
    case marketTypes.MT_12_ID:
    case marketTypes.MT_DNB_ID:
      return [Outcomes.OUTCOME_1, Outcomes.OUTCOME_2];

    case marketTypes.MT_DC_ID:
      return [Outcomes.OUTCOME_1X, Outcomes.OUTCOME_X2, Outcomes.OUTCOME_12];

    case marketTypes.MT_OU_ID:
      return [Outcomes.OUTCOME_OVER, Outcomes.OUTCOME_UNDER];

    case marketTypes.MT_BTS_ID:
      return [Outcomes.OUTCOME_YES, Outcomes.OUTCOME_NO];
  }

  return [];
}

export function getOutcomeLabel(outcomeName: string): string {
  switch (outcomeName) {
    case Outcomes.OUTCOME_OVER:
      return _t('Over');

    case Outcomes.OUTCOME_UNDER:
      return _t('Under');

    case Outcomes.OUTCOME_YES:
      return _t('Yes');

    case Outcomes.OUTCOME_NO:
      return _t('No');

    case Outcomes.OUTCOME_EXACT:
      return _t('Exact');

    case Outcomes.OUTCOME_ODD:
      return _t('Odd');

    case Outcomes.OUTCOME_EVEN:
      return _t('Even');

    case Outcomes.OUTCOME_1:
      return _t('Home');

    case Outcomes.OUTCOME_X:
      return _t('Draw');

    case Outcomes.OUTCOME_2:
      return _t('Away');
  }

  return outcomeName;
}

export const getOutcomeLetter = (outcome: Outcomes): string => {
  let outcomeLetter: string = '';

  switch (outcome) {
    case Outcomes.OUTCOME_1:
      outcomeLetter = _t('1');
      break;
    case Outcomes.OUTCOME_X:
      outcomeLetter = _t('X');
      break;
      case Outcomes.OUTCOME_2:
      outcomeLetter = _t('2');
      break;
    default:
      outcomeLetter = '';
  }

  return outcomeLetter;
}
